import React from "react";
// Assuming you have a hook to access your context
import { useAppointment } from "./AppointmentContext";
import "../Style/MobileButton.css";
const MobileBookButton = () => {
  const { handleAppointment } = useAppointment();

  return (
    <button
      className="mobile-book-button"
      onClick={handleAppointment}
      aria-label="Book an appointment"
    >
      Book Appointment
    </button>
  );
};

export default MobileBookButton;
